import { useMemo } from "react"
import { DateRange } from "../../../types"
import ButtonGroup, { ButtonProps } from "../button-group"

interface DaysFilterProps {
  className?: string
  range: number
  handleUpdateRange: (range: DateRange) => void
  visibleRanges?: DateRange[]
  size?: "sm" | "base" | "md" | "lg"
}

const DaysFilter = ({
  className = "",
  range,
  handleUpdateRange,
  visibleRanges = [1, 7, 30, 1000],
  size = "base"
}: DaysFilterProps) => {
  const FILTER_BUTTONS: ButtonProps[] = useMemo(() => {
    const allButtons = [
      {
        key: 1000,
        label: "All time",
        shortLabel: "All",
        disabled: false,
        onClick: () => handleUpdateRange(1000)
      },
      {
        key: 60,
        label: "60 Days",
        shortLabel: "60 D",
        disabled: false,
        onClick: () => handleUpdateRange(60)
      },
      {
        key: 30,
        label: "30 Days",
        shortLabel: "30 D",
        disabled: false,
        onClick: () => handleUpdateRange(30)
      },
      {
        key: 7,
        label: "7 Days",
        shortLabel: "7 D",
        disabled: false,
        onClick: () => handleUpdateRange(7)
      },
      {
        key: 1,
        label: "24 hours",
        shortLabel: "24 H",
        disabled: false,
        onClick: () => handleUpdateRange(1)
      }
    ]

    if (visibleRanges) {
      return visibleRanges
        .map(range => allButtons.find(button => button.key === range))
        .filter(
          (button): button is NonNullable<typeof button> => button !== undefined
        )
    }

    return allButtons
  }, [handleUpdateRange, visibleRanges])

  return (
    <ButtonGroup
      size={size}
      className={className}
      buttons={FILTER_BUTTONS}
      active={range}
    />
  )
}

export default DaysFilter
